/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ALIGN, ICard, ImageContent, IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import "../../../../assets/css/cards.scss"
import { ICardsProps } from "../Cards"
import AccordeonCard from "./AccordeonCard"
import DataContentEditor from "../../landing-edit/editors/data-content-editor"
import { ImagePrimitive } from "../../primitive"
import getTypographyStyle from "../../../utils/getTypographyStyle"

/* Protopia Ecosystem component */
const CardAccordeon = ({data, ...props}: ICardsProps): JSX.Element => {
    const thumbRef          = useRef<HTMLDivElement>(null)
    const composition       = useComposition(props.section)
    const current           = useSyncState( 0 )
    const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)    || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align)      || !data.vertical_align   ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align)    || !data.vertical_align   ? "auto" : "0")
    const [width]           = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]        = useState<string>(getCssDemention( data.height, "fit-content" ))
    const [thumbnailSize, setThumbnailSize] = useState<IScreenPosition>({ width: "100%", height: "100%" })
 
    useEffect(() => {
        addCSSClass(
            `landing-cards-${props.section.id}`,
            `.landing-cards-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                min-height: ${ height }; 
                width: ${ width };
                width: 100%;
                flex-direction: column;
                z-index:1;
                .accordeon-btn .my-title {
                    ${getTypographyStyle( data.cardTitleTypography )}
                }
            } 
            `
        )        
        if(thumbRef.current) {
            const thumb = thumbRef.current
            setThumbnailSize({
                width:  thumb.clientWidth,
                height: thumb.clientHeight,
                aspect: thumb.clientWidth / thumb.clientHeight
            })
        }
        return () => {
            removeCSSClass(`landing-card-${props.section.id}`)
        }
    },[])
       
    useEffect(()=> { 
    }, [ composition, current.get() ])  
    
    return <div className={`pe-cards-container landing-content-container`} data-type={data.type} data-content-id={data.id}>        
        <div 
            className="landing-cards-container" 
            style={{ 
                gridTemplateColumns: data.isRightThumbnail 
                    ? 
                    `${100 - 100* (data.proportia || .5)}% ${100 * (data.proportia || .5) }%`
                    :
                    `${100* (data.proportia || .5)}% ${100 - 100 * (data.proportia || .5) }%`
            }}
        >    
            {
                data.thumbnail && 
                    <div className={`cards-thumbnail cards-thumbnail-${ data.id } ${ data.isRightThumbnail ? "is-right" : ""}`} ref={thumbRef}>
                        {
                            thumbnailSize.width !== "100%" && 
                                <>
                                    <ImagePrimitive 
                                        section={props.section}
                                        field="thumbnail"
                                        primitive={{
                                            ...data.thumbnail, 
                                            id: `thumbnail-${data.id}`,
                                            position: { ...thumbnailSize },
                                            data: { ...(data.thumbnail ? data.thumbnail.data : {}), src_type: "div" } 
                                        } as ImageContent }
                                    />
                                </>
                        } 
                    </div>
            }    
            <div className={`landing-cards landing-cards-${props.section.id} ${ data.className || "" } `} >
                {
                    data.cards.map((card: ICard, i: number) =>  { 
                        return <AccordeonCard
                            key={ card.id }
                            data={ { ...card, i: i } }
                            i={ i }
                            width={ 100 }
                            contentData={ data }
                            section={ props.section }
                            isOpen={ i === current.get() }
                            setOpen={() => current.set(i)}
                        />
                    })
                } 
            </div>
            <DataContentEditor data={data} section={props.section}  />
        </div>
    </div>
}

export default CardAccordeon